document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-pt-faq-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('[data-open]');
      var sign = btn.querySelector('[data-pt-faq-sign]');
      var open = item.getAttribute('data-open') === 'true';
      item.setAttribute('data-open', open ? 'false' : 'true');
      if (sign) sign.textContent = open ? '+' : '−';
    });
  });
});
